import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { GenerateProductDescriptionRootParamList } from "../../../../types";
import { ProductDescriptionLlmQuickWinScreen } from "./ProductDescriptionLlmQuickWinScreen";
import { GenerateProductDescriptionForm } from "../../components/GenerateProductDescriptionForm";
import { ProductFormValues } from "../../components/ProductForm/types";
import { useFormContext } from "react-hook-form";
import { SelectProductDescriptionToneScreen } from "./SelectProductDescriptionToneScreen";

export type GenerateProductDescriptionRootScreenProps = StackScreenProps<
  any,
  "GenerateProductDescriptionRootScreen"
>;

const StackNavigator =
  createStackHeaderNavigator<GenerateProductDescriptionRootParamList>();

export const GenerateProductDescriptionRootScreen = () => {
  const { watch, getValues } = useFormContext<ProductFormValues>();
  const [name, tags = [], departmentId, categoryId, description] = watch([
    "name",
    "tags",
    "departmentId",
    "categoryId",
    "description",
  ]);

  return (
    <GenerateProductDescriptionForm
      defaultFormValues={{
        productName: name,
        productFeaturesAndTags: tags.join(", "),
        numberOfSentences: undefined,
        departmentId: departmentId,
        categoryId: categoryId,
        existingDescription: description,
      }}
    >
      <StackNavigator.Navigator
        screenOptions={{
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Cancel" />,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <StackNavigator.Screen
          name="ProductDescriptionLlmQuickWinScreen"
          component={ProductDescriptionLlmQuickWinScreen}
        />
        <StackNavigator.Screen
          name="SelectProductDescriptionToneScreen"
          component={SelectProductDescriptionToneScreen}
        />
      </StackNavigator.Navigator>
    </GenerateProductDescriptionForm>
  );
};
